import { memo, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { IAppTag } from 'src/services/AppService';
import { tagConfigSelector } from 'src/selectors/app';
import { ArrayUtils } from 'src/utils';
import { Element, Image } from 'src/components';
import Navbar from 'src/components/navbar';
import Menu from 'src/components/menu';

export function HotTagSection() {
    let tags = useSelector(tagConfigSelector) as IAppTag[];

    const renderTags = useCallback(() => {
        return tags.map((item: IAppTag, index: number) => (
            <Navbar.Item
                key={`navbar.item.${index}`}
                className={twMerge(
                    'group/topic',
                    'inline-block',
                    'text-[14px] leading-[1] ',
                    'h-[44px]',
                    'rounded-full',
                    'bg-white',
                    'border border-solid border-[#E5E5E5]',
                    'active:bg-black/[0.2]',
                    'mr-[4px]',
                )}
            >
                <Navbar.Link
                    to={item.url}
                    as={item.url}
                    classNameLink="flex items-center h-full px-[12px] text-[15px] font-semibold"
                    className="h-full"
                >
                    <Element
                        className={cn('text-[#F05B2F] text-[15px]', 'mr-[8px]')}
                    >
                        #
                    </Element>
                    <Element renderAs="span" className="whitespace-nowrap">
                        {item.name.replaceAll('#', '')}
                    </Element>
                </Navbar.Link>
            </Navbar.Item>
        ));
    }, [tags]);

    if (ArrayUtils.isEmpty(tags)) {
        return null;
    }

    return (
        <Element
            className={cn(
                'relative',
                'px-[20px] py-[16px] my-[20px] ml-[-20px]',
                'w-[calc(100%+40px)]',
                'bg-[#F5F6F7]',
            )}
        >
            <Element className="flex items-center">
                <Image
                    src="https://baomoi-static.bmcdn.me/web/styles/img/ic-trending.svg"
                    className="w-[16px] h-[16px] mr-[8px] shrink-0"
                />
                <Element
                    className={cn(
                        'text-[16px] font-[800] text-[#F05B2F]',
                        'uppercase',
                    )}
                >
                    Chủ đề
                </Element>
            </Element>
            <Menu.List
                className={cn(
                    'w-full whitespace-nowrap overflow-x-auto mt-[8px]',
                    '[scrollbar-width:none]',
                    '[&::-webkit-scrollbar]:hidden',
                )}
            >
                {renderTags()}
            </Menu.List>
        </Element>
    );
}

export default memo(HotTagSection);
